// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const whiscash: PokeData = {
  "id": 340,
  "name": "whiscash",
  "height": 9,
  "weight": 236,
  "base_experience": 164,
  "types": [
    PokeType.WATER,
    PokeType.GROUND
  ],
  "api_moves": [
    "thrash",
    "water-gun",
    "earthquake",
    "fissure",
    "amnesia",
    "rest",
    "snore",
    "mud-slap",
    "magnitude",
    "future-sight",
    "mud-sport",
    "tickle",
    "muddy-water",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "earth-power",
    "mud-bomb",
    "zen-headbutt",
    "belch"
  ],
  "moves": [
    "earthquake",
    "fissure",
    "mud-slap",
    "magnitude",
    "future-sight",
    "aqua-tail",
    "earth-power",
    "mud-bomb",
    "zen-headbutt",
    "bubble",
    "sandstorm",
    "mud-shot",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 173,
    "item": null,
    "species": [
      {
        "name": "barboach",
        "order": 367,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whiscash",
        "order": 368,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 339,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 159,
    "speed": 105,
    "ability_power": 136
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
